
// const cors = 'https://cors-anywhere.herokuapp.com/';
const url = 'https://api.hvandorpmaps.com';
const version = 'v1';
export default {
  LICENSE: `${url}/${version}/license/`,
  AVAILABLE: `${url}/${version}/available/`,
  CONFIRM: `${url}/${version}/confirm/`,
}


// WEBPACK FOOTER //
// ./src/api/endpoints.js